/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MetricConfigItems {
    getFixupPrototypeFunction() { return MetricConfigItems.fixupPrototype; }

    static newInstance(model: Partial<MetricConfigItems>): MetricConfigItems {
        let obj = Object.assign(new MetricConfigItems(), model);
        MetricConfigItems.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MetricConfigItems>): MetricConfigItems {
        if (!model) return null;
        return MetricConfigItems.newInstance(<MetricConfigItems> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MetricConfigItems) {
        if (!obj) return;

        models.MetricConfigItems.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MetricConfigItems): boolean {
        Object.setPrototypeOf(obj, MetricConfigItems.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.evaluationPeriods === undefined) {
            this.evaluationPeriods = 0;
        }
        if (this.period === undefined) {
            this.period = 0;
        }
        if (this.threshold === undefined) {
            this.threshold = 0;
        }
    }

    /**
     * Evaluation periods retrieved successfully
     */
    evaluationPeriods: number;

    /**
     * Dimensions retrieved successfully
     */
    dimensions: Array<string>;

    /**
     * Alarm actions retrieved successfully
     */
    alarmActions: Array<string>;

    /**
     * Alarm description retrieved successfully
     */
    alarmDescription: string;

    /**
     * Namespace retrieved successfully
     */
    namespace: string;

    /**
     * Period retrieved successfully
     */
    period: number;

    /**
     * Comparison Operator retrieved successfully
     */
    comparisonOperator: string;

    /**
     * Statistic retrieved successfully
     */
    statistic: string;

    /**
     * Threshold retrieved successfully
     */
    threshold: number;

    /**
     * Okactions retrieved successfully
     */
    oKActions: Array<string>;

}
